<template>
	<side-window :tabs="[]" :active="active" class="contact" title="Fravær" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<form-line-layout>
						<employee-select-view v-model="ent" label="Medarbejder" :optional="true" />
					</form-line-layout>
					<form-line-layout>
						<select-view label="Type" v-model="ent.leave_type_id" :options="_leave_types" />
					</form-line-layout>
					<form-line-layout>
						<date-select-view label="Fra" v-model="ent.from_date" :controller="$store.state.popupController" />
						<date-select-view label="Til" v-model="ent.to_date" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout v-show="false">
						<date-select-view label="Dato" v-model="ent.from_date" :controller="$store.state.popupController" />
					</form-line-layout>
					<div class="side-window__heading">
						Specifikt tidsrum
						<switch-view v-model="ent.time" />
					</div>
					<form-line-layout v-show="ent.time">
						<clock-select-view display="time" label="Fra" v-model="ent.from_time" :controller="$store.state.popupController" />
						<clock-select-view display="time" label="Til" v-model="ent.to_time" :controller="$store.state.popupController" />
					</form-line-layout>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				types: [],
				status: [],
				employees: [],
				vehicles: [],
				leave: [],

				ent: {
					time: false,
					employee_id: null,
					leave_type_id: null,
					from_date: (new Date()).format('Y-m-d'),
					to_date: (new Date()).format('Y-m-d'),
					from_time: 0,
					to_time: 0,
					_embedded: {
						employee: {
							name: ''
						},
					}
				}
			};
		},
		watch: {
	
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'employees',
						label: 'Medarbejdere'
					},
					{
						name: 'vehicles',
						label: 'Køretøjer'
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_leave_types() {
				return this.types.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function () {}
			},
			entity: {
				type: Object,
				default() {
					return {
						employee_id: null,
						leave_type_id: null,
						from_date: null,
						to_date: null,
						from_time: null,
						to_time: null,
						_embedded: {
							employee: {
								name: 'None'
							},
						}
					};
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				//console.log(this.ent);

				this.submit(this.ent);
			}
		},
		mounted: function() {

			this.axios.put('/activity/leave/');

			// Set ent
			this.ent = merge(this.ent, this.entity);

			var d = new Date(this.ent.from_date);	

			var self = this;

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/employees/leave/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get(`/employees/leave/${d.getFullYear()}/${d.getMonth() + 1}`)
				.then(function (r) {
					self.leave = r.data.filter((item) => {
						return item.id == self.ent.employee_id;
					})[0];

					console.log(self.leave, d.getDate());

					self.ent.from_time = self.leave[d.getDate()].time_from || 0;
					self.ent.to_time = self.leave[d.getDate()].time_to || 0;
				});

			this.axios
				.get('/employees/')
				.then(function (r) {
					self.employees = r.data._items;
					//self.departments = r.data._items;


					// Set emp
					if (self.ent.employee_id) {
						self.ent._embedded.employee = self.employees.find(function (ent) {
							return ent.id == self.ent.employee_id;
						});
					}
					
				});

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					self.vehicles = r.data._items;
					//self.departments = r.data._items;
				});

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
